export default __webpack_public_path__ + "static/img/logo-platform.33d28022499b9a0cef2e6433d377297f.png";